import RestService from './RestService';

export default class MicrosoftDefenderAstService extends RestService {
    constructor(companiesService, companyId) {
        if (!companiesService || !companyId) {
            throw new Error('Companies service and companyId are required');
        }
        super(
            `${companiesService.baseUrl}/${companyId}/integration/microsoft-defender-ast`
        );
        this.companyId = companyId;
    }

    status() {
        return this.get(`${this.baseUrl}/status`);
    }

    disconnect() {
        return this.del(`${this.baseUrl}/connection`);
    }

    listPayloads(filter) {
        const params = filter ? { filter } : {};
        return this.get(`${this.baseUrl}/payloads`, params);
    }

    /**
     * Paged payloads (Graph $top / $skipToken) via API. Pass top for paged mode.
     * @param {{ top?: number, skipToken?: string, search?: string, scope?: string, count?: boolean|string|number }} opts
     */
    listPayloadsPage(opts = {}) {
        const params = {};
        if (opts.top != null) params.top = opts.top;
        if (opts.skipToken) params.skipToken = opts.skipToken;
        if (opts.search != null && opts.search !== '') params.search = opts.search;
        if (opts.scope) params.scope = opts.scope;
        if (opts.count === true || opts.count === '1' || opts.count === 1) {
            params.count = '1';
        }
        return this.get(`${this.baseUrl}/payloads`, params);
    }

    previewPayload(graphPayloadId) {
        return this.get(
            `${this.baseUrl}/payloads/${encodeURIComponent(graphPayloadId)}/preview`
        );
    }

    listSimulations() {
        return this.get(`${this.baseUrl}/simulations`);
    }

    /**
     * Hydrated simulation record incl. resolved `payload`, `landingPage`, `loginPage`
     * and the full `trainingSetting` / `endUserNotificationSetting` shapes — used by
     * the Simulations details drawer to verify which training shape Microsoft accepted.
     */
    getSimulation(graphSimulationId) {
        return this.get(
            `${this.baseUrl}/simulations/${encodeURIComponent(graphSimulationId)}`
        );
    }

    localSimulations() {
        return this.get(`${this.baseUrl}/local-simulations`);
    }

    defaults() {
        return this.get(`${this.baseUrl}/defaults`);
    }

    getLandingPage(graphLandingId) {
        return this.get(
            `${this.baseUrl}/landing-pages/${encodeURIComponent(graphLandingId)}`
        );
    }

    getLoginPage(graphLoginId) {
        return this.get(
            `${this.baseUrl}/login-pages/${encodeURIComponent(graphLoginId)}`
        );
    }

    createSimulation(body) {
        return this.post(`${this.baseUrl}/simulations`, body);
    }

    /** Single POST: hidden list + training + Microsoft simulation (server-orchestrated). */
    createWizardSimulation(body) {
        return this.post(`${this.baseUrl}/wizard/simulations`, body);
    }

    deleteSimulation(graphId) {
        return this.del(
            `${this.baseUrl}/simulations/${encodeURIComponent(graphId)}`
        );
    }

    ingest() {
        return this.post(`${this.baseUrl}/ingest`, {});
    }

    riskDashboard() {
        return this.get(`${this.baseUrl}/risk-dashboard`);
    }

    customUrlPreview(graphSimulationId, userEmail) {
        return this.get(`${this.baseUrl}/custom-urls/preview`, {
            graphSimulationId,
            userEmail,
        });
    }

    recordPhishGuardSignal(body) {
        return this.post(`${this.baseUrl}/phishguard-signal`, body);
    }
}
